import React, { useEffect, useState, useRef } from 'react';
import { cn } from '../../lib/utils';
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);
  return <div ref={ref} className={cn('transition-all duration-700 ease-out transform', isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8', className)} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-390">
      {children}
    </div>;
}